module.exports = __webpack_public_path__ + "img/DNADamage-OSCC_GSE208253.2f43cc76.png";